// Models
import { BaseModel } from '../../../woopa-ui/api';

/**
* Represents a repair set in the app.
*/
export interface RepairSet extends BaseModel {
  createdAt: string;
  count: number;
  status: number;
  repairEntries: any[];
}

/**
 * List of repair statuses.
 */
export const REPAIR_STATUSES = ['Cerrada', 'Abierta', 'Nueva'];

/**
 * List of repair entry statuses.
 */
export const REPAIR_ENTRY_STATUSES = ['Creado', 'Reincorporado', 'Eliminado'];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/models/repair-set.interface.ts